function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { createElement as h, Component } from 'react';
import StatusBarPlugin from '@uppy/status-bar';
import { uppy as uppyPropType } from './propTypes.js';
import getHTMLProps from './getHTMLProps.js';
import nonHtmlPropsHaveChanged from './nonHtmlPropsHaveChanged.js';
/**
 * React component that renders a status bar containing upload progress and speed,
 * processing progress and pause/resume/cancel controls.
 */

var StatusBar = /*#__PURE__*/function (_Component) {
  _inherits(StatusBar, _Component);

  var _super = _createSuper(StatusBar);

  function StatusBar() {
    _classCallCheck(this, StatusBar);

    return _super.apply(this, arguments);
  }

  _createClass(StatusBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.installPlugin();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // eslint-disable-next-line react/destructuring-assignment
      if (prevProps.uppy !== this.props.uppy) {
        this.uninstallPlugin(prevProps);
        this.installPlugin();
      } else if (nonHtmlPropsHaveChanged(this.props, prevProps)) {
        var options = _objectSpread(_objectSpread({}, this.props), {}, {
          target: this.container
        });

        delete options.uppy;
        this.plugin.setOptions(options);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.uninstallPlugin();
    }
  }, {
    key: "installPlugin",
    value: function installPlugin() {
      var _this$props = this.props,
          uppy = _this$props.uppy,
          hideUploadButton = _this$props.hideUploadButton,
          hideRetryButton = _this$props.hideRetryButton,
          hidePauseResumeButton = _this$props.hidePauseResumeButton,
          hideCancelButton = _this$props.hideCancelButton,
          showProgressDetails = _this$props.showProgressDetails,
          hideAfterFinish = _this$props.hideAfterFinish,
          doneButtonHandler = _this$props.doneButtonHandler;
      var options = {
        id: 'react:StatusBar',
        hideUploadButton: hideUploadButton,
        hideRetryButton: hideRetryButton,
        hidePauseResumeButton: hidePauseResumeButton,
        hideCancelButton: hideCancelButton,
        showProgressDetails: showProgressDetails,
        hideAfterFinish: hideAfterFinish,
        doneButtonHandler: doneButtonHandler,
        target: this.container
      };
      delete options.uppy;
      uppy.use(StatusBarPlugin, options);
      this.plugin = uppy.getPlugin(options.id);
    }
  }, {
    key: "uninstallPlugin",
    value: function uninstallPlugin(props) {
      if (props === void 0) {
        props = this.props;
      }

      var _props = props,
          uppy = _props.uppy;
      uppy.removePlugin(this.plugin);
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      return /*#__PURE__*/h('div', _objectSpread({
        className: 'uppy-Container',
        ref: function ref(container) {
          _this.container = container;
        }
      }, getHTMLProps(this.props)));
    }
  }]);

  return StatusBar;
}(Component);

// Must be kept in sync with @uppy/status-bar/src/StatusBar.jsx.
StatusBar.defaultProps = {
  hideUploadButton: false,
  hideRetryButton: false,
  hidePauseResumeButton: false,
  hideCancelButton: false,
  showProgressDetails: false,
  hideAfterFinish: true,
  doneButtonHandler: null
};
export default StatusBar;